module.exports = __webpack_public_path__ + "img/minion_wave_thumb.9ac74ff3.jpg";